//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
let d=[[[0,"Dump",1,0],[0,"Output",1,0],[0,"OutputToFileName",1,0]],[[["type"],"GetTrace",{R_:{state:''}},1,0],[["type","state"],"SetTrace",{},2,0]],[]];
SPLM.SIM.PostConfigurator.PostConfiguratorDebugBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.PostConfiguratorDebugBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.PostConfigurator.PostConfiguratorDebugBuilder.TraceType = Object.freeze({
    "CreatePostprocessor" : "CreatePostprocessor", "SelectPostprocessor" : "SelectPostprocessor"});

SPLM.SIM.PostConfigurator.PostConfiguratorDebugBuilder.DumpType = Object.freeze({
    "None" : "None", "ShowChanges" : "ShowChanges", "ShowAllSettings" : "ShowAllSettings"});

SPLM.SIM.PostConfigurator.PostConfiguratorDebugBuilder.OutputType = Object.freeze({
    "Syslog" : "Syslog", "ListingWindow" : "ListingWindow", "Xml" : "Xml", "ToFile" : "ToFile"});

export default SPLM;